export function Logo({ light = false, className = "", showText = true }) {
  return (
    <div className={`flex items-center gap-2.5 ${className}`} data-testid="app-logo">
      <svg width="34" height="34" viewBox="0 0 40 40" fill="none" xmlns="http://www.w3.org/2000/svg" className="shrink-0">
        <path d="M3 8L9 30L15 12L21 30L27 8" stroke="#2563EB" strokeWidth="4.5" strokeLinecap="round" strokeLinejoin="round" />
        <path d="M27 8L33 30" stroke="#10B981" strokeWidth="4.5" strokeLinecap="round" strokeLinejoin="round" />
        <circle cx="33" cy="4.5" r="3" fill="#10B981" />
      </svg>
      {showText && (
        <div className="leading-none">
          <div
            className={`font-extrabold tracking-tight text-[15px] ${light ? "text-white" : "text-navy"}`}
          >
            VACANCY
          </div>
          <div className="text-[9px] font-semibold tracking-[0.32em] text-accent -mt-0.5">
            NETWORK
          </div>
        </div>
      )}
    </div>
  );
}
